export default class HereAvailableHandler {
  constructor() {
    if (this.dependencies()) {
      this.addEventListeners();
    }
  }

  dependencies = () => {
    this.hereAvailableWidget = document.querySelector(".here-available-widget");
    if (this.hereAvailableWidget == null) return false;

    let regionsString = this.hereAvailableWidget.dataset?.regions;
    if (regionsString == null) return false;

    this.regions = JSON.parse(regionsString);
    if (this.regions == null) return false;

    this.select = this.hereAvailableWidget.querySelector(".here-available-widget__select");
    if (this.select == null) return false;

    this.button = this.hereAvailableWidget.querySelector(".here-available-widget__button");
    if (this.button == null) return false;

    this.modal = this.hereAvailableWidget.querySelector(".here-available-widget__modal");
    if (this.modal == null) return false;

    this.modalTitle = this.modal.querySelector(".here-available-widget__modal-title");
    if (this.modalTitle == null) return false;

    this.modalCloseBtn = this.modal.querySelector(".here-available-widget__modal-close");
    if (this.modalCloseBtn == null) return false;

    this.modalItemTemplate = this.modal.querySelector(
      ".here-available-widget__modal-item-template"
    );
    if (this.modalItemTemplate == null) return false;

    this.modalVendorsContainer = this.modal.querySelector(
      ".here-available-widget__modal-vendors-container"
    );
    if (this.modalVendorsContainer == null) return false;

    this.noVendors = this.hereAvailableWidget.querySelector(".here-available-widget__no-vendors");
    if (this.noVendors == null) return false;

    return true;
  };

  addEventListeners = () => {
    this.select.addEventListener("change", this.handleSelectChange);
    this.button.addEventListener("click", this.handleButtonClick);
    this.modalCloseBtn.addEventListener("click", this.handleCloseModalClick);
  };

  handleSelectChange = () => {
    this.selectedIndex = this.select.value;
  };

  handleButtonClick = () => {
    if (this.selectedIndex >= 0) {
      let selectedItem = this.regions[this.selectedIndex];

      if (!Array.isArray(selectedItem.vendors) || selectedItem.length <= 0) {
        this.noVendors.classList.remove("hidden");
        return;
      } else if (!this.noVendors.classList.contains("hidden")) {
        this.noVendors.classList.add("hidden");
      }

      this.modalTitle.innerHTML = selectedItem.text;
      this.loadVendors(selectedItem);
      this.modal.classList.toggle("hidden");
      this.lockScroll();
    }
  };

  loadVendors = (selectedItem) => {
    this.modalVendorsContainer.innerHTML = "";
    selectedItem.vendors.forEach((vendor) => {
      this.addVendor(vendor);
    });
  };

  addVendor = (vendor) => {
    let itemTemplateString = this.modalItemTemplate.outerHTML;
    itemTemplateString = itemTemplateString
      .replace("{vendorName}", vendor.title)
      .replace("{vendorDescription}", vendor.text)
      .replace("{vendorLink}", vendor.link);
    const parser = new DOMParser();
    const doc = parser.parseFromString(itemTemplateString, "text/html");
    const item = doc.body.firstChild;
    item.classList.add("here-available-widget__modal-item");
    item.classList.add("flex");
    item.classList.remove("here-available-widget__modal-item-template");
    item.classList.remove("hidden");
    this.modalVendorsContainer.appendChild(item);
  };

  handleCloseModalClick = () => {
    this.modal.classList.toggle("hidden");
    this.unlockScroll();
  };

  lockScroll = () => {
    document.body.classList.add("overflow-hidden");
    document.documentElement.classList.add("overflow-hidden");
  };

  unlockScroll = () => {
    document.body.classList.remove("overflow-hidden");
    document.documentElement.classList.remove("overflow-hidden");
  };
}
